<h1>Kontaktuppgifter</h1>
<form [formGroup]="applicantsForm()">
  <p>Vänligen ange dina kontaktuppgifter</p>

  <div class="form-row"
       [class.small-screen]="orientationService.isSmallScreen()">
    <mat-form-field class="disabled-gray-background">
      <mat-label>Personnummer</mat-label>
      <input readonly formControlName="personalNumber" matInput type="text"
             spbPersonnummerValidator tabindex="-1">
    </mat-form-field>

    <mat-form-field
      [class.disabled-gray-background]="!savingsAccountService.applicant().sparFailed">
      <mat-label>För- och efternamn</mat-label>
      <input [readonly]="!savingsAccountService.applicant().sparFailed"
             formControlName="name" matInput type="text" tabindex="-1">
    </mat-form-field>
  </div>

  <div class="form-row"
       [class.small-screen]="orientationService.isSmallScreen()">
    <mat-form-field
      [class.disabled-gray-background]="!savingsAccountService.applicant().sparFailed">
      <mat-label>Gata</mat-label>
      <input [readonly]="!savingsAccountService.applicant().sparFailed"
             formControlName="streetAdress" matInput type="text" tabindex="-1">
    </mat-form-field>

    <mat-form-field
      [class.disabled-gray-background]="!savingsAccountService.applicant().sparFailed">
      <mat-label>Hus/lägenhetsnummer</mat-label>
      <input [readonly]="!savingsAccountService.applicant().sparFailed"
             formControlName="streetNumber" matInput type="text" tabindex="-1">
    </mat-form-field>
  </div>

  <div class="form-row split-1-to-3"
       [class.small-screen]="orientationService.isSmallScreen()">
    <mat-form-field
      [class.disabled-gray-background]="!savingsAccountService.applicant().sparFailed">
      <mat-label>Postnummer</mat-label>
      <input
        [readonly]="!savingsAccountService.applicant().sparFailed"
        inputmode="numeric"
        formControlName="postalCode"
        matInput
        type="text"
        maxlength="6"
        tabindex="-1">
    </mat-form-field>

    <mat-form-field
      [class.disabled-gray-background]="!savingsAccountService.applicant().sparFailed">
      <mat-label>Ort</mat-label>
      <input [readonly]="!savingsAccountService.applicant().sparFailed"
             formControlName="city" matInput type="text" tabindex="-1">
    </mat-form-field>
  </div>

  <div class="form-row split-1-to-3"
       [class.small-screen]="orientationService.isSmallScreen()">

    <mat-form-field class="disabled-gray-background">
      <mat-label>Landskod</mat-label>
      <input matInput formControlName="countryCode" readonly value="+46"
             tabindex="-1">

      @if (applicantsForm().controls.countryCode.errors && applicantsForm().controls.countryCode.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }
      <mat-error>Ange landskod</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Mobilnummer</mat-label>
      <input formControlName="phone"
             placeholder="Mobilnummer"
             inputmode="numeric"
             matInput type="tel"
             (blur)="formatPhone(applicantsForm().controls.phone)">

      @if (applicantsForm().controls.phone.errors && applicantsForm().controls.phone.touched) {
        <mat-icon matIconSuffix aria-hidden="true">
          priority_high
        </mat-icon>
      }

      <mat-error>{{ applicantsForm().controls.phone.errors?.error.message }}</mat-error>
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>E-post</mat-label>
    <input
      placeholder="E-post"
      formControlName="email" matInput type="text">
    @if (applicantsForm().controls.email.errors && applicantsForm().controls.email.touched) {
      <mat-icon matIconSuffix aria-hidden="true">
        priority_high
      </mat-icon>
    }
    <mat-error>Ange en korrekt e-postadress</mat-error>
  </mat-form-field>

</form>
